export default function getClient() {
  return window?.nvg53215;
}
